import React, { useContext, useEffect, useState } from "react";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import {
    Badge,
    Button,
    Form,
    Input,
    Modal,
    Table,
    Tag,
    Typography,
} from "antd";
import moment from "jalali-moment";
import { toast } from "react-toastify";

const InteractionsTable = () => {
    const [form] = Form.useForm();

    //persian
    const PN = require("persian-number");
    //context
    const {
        forceUpdate,
        setForceUpdate,
        isInteractionModalOpen,
        setIsInteractionModalOpen,
    } = useContext(context);
    //states
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [sentSMS, setSentSMS] = useState("");
    const [numberSms, setNumberSms] = useState();
    //functions
    const handleOk = () => {
        http.post(`${config.parkopoloApi}/api/Interaction/SMS`, {
            message: sentSMS,
            count: numberSms,
        })
            .then((res) => {
                toast.success("پیامک با موفقیت ساخته شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
                setForceUpdate(16);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                setForceUpdate(15);
            });
        setIsInteractionModalOpen(false);
        setSentSMS("");
    };

    const handleCancel = () => {
        setIsInteractionModalOpen(false);
    };
    //api
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Interaction/SMS`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);

    const columns = [
        {
            title: "متن پیامک",
            dataIndex: "message",
            width: "10%",
        },
        {
            title: "تاریخ پیامک",
            dataIndex: "createdAt",
            width: "10%",

            render: (_, { createdAt }) => (
                <>
                    <Typography.Paragraph>
                        {PN.convertEnToPe(
                            moment(createdAt.slice(0, 10), "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                        )}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "هزینه پیامک",
            width: "5%",
            render: (_, { cost }) => (
                <>
                    <Typography.Paragraph>
                        <Tag color="cyan">
                            {cost}
                            {" تومان"}
                        </Tag>
                    </Typography.Paragraph>
                </>
            ),
        },
    ];
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
            />
            <Modal
                title="ساخت پیامک جدید"
                open={isInteractionModalOpen}
                okButtonProps={{ hidden: true }}
                cancelButtonProps={{ hidden: true }}
                onCancel={handleCancel}
            >
                <Form
                    onFinish={handleOk}
                    layout="vertical"
                    form={form}
                    name="control-hooks"
                    style={{
                        direction: "rtl",
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        justifyContent:"center"
                        // margin: "15px",
                    }}
                >
                    <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="پاسخ"
                    >
                       <div style={{marginTop:"10px"}}>
                       <Badge.Ribbon
                            placement="start"
                            style={{ marginTop: "-18px", marginRight: "10px" }}
                            text="متن پیامک"
                        >
                            <Input
                                style={{ margin: "10px", width: "90%" }}
                                placeholder="پیامی بنویسید..."
                                onChange={(e) => {
                                    setSentSMS(e.target.value);
                                }}
                            />
                        </Badge.Ribbon>
                       </div>
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="پاسخ"
                    >
                        <Badge.Ribbon
                            placement="start"
                            style={{ marginTop: "-18px", marginRight: "10px" }}
                            text="تعداد پیامک ارسالی به کاربران"
                        >
                            <Input
                                type="number"
                                style={{ margin: "10px", width: "90%" }}
                                placeholder="تعداد را وارد کنید..."
                                onChange={(e) => {
                                    setNumberSms(e.target.value);
                                }}
                            />
                        </Badge.Ribbon>
                    </Form.Item>
                    <Form.Item>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                alignItems: "center",                        
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                ثبت
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={handleCancel}
                            >
                                لغو
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default InteractionsTable;
